const formatDateTime = time => {
    const date = new Date(time);
    const y = date.getFullYear();
    let m = date.getMonth() + 1;

    m = m < 10 ? `0${m}` : m;
    let d = date.getDate();

    d = d < 10 ? `0${d}` : d;
    let h = date.getHours();

    h = h < 10 ? `0${h}` : h;
    let minute = date.getMinutes();
    let second = date.getSeconds();

    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;

    return `${y}-${m}-${d} ${h}:${minute}:${second}`;
};

// const add0 = m => {
//     return m < 10 ? `0${ m}` : m;
// };
//
// const formatDateTime = shijianchuo => {
//     // shijianchuo是整数，否则要parseInt转换
//     const time = new Date(shijianchuo);
//     const y = time.getFullYear();
//     const m = time.getMonth() + 1;
//     const d = time.getDate();
//     const h = time.getHours();
//     const mm = time.getMinutes();
//     const s = time.getSeconds();
//
//     return `${y}-${ add0(m) }-${ add0(d) } ${ add0(h) }:${ add0(mm) }:${ add0(s)}`;
// };

export { formatDateTime };
